export type SupportedLanguage = 'en' | 'de';

/**
 * Gets user's preferred language from browser navigator
 * @returns 'en' for English browsers, 'de' for all others (safe fallback)
 * @example
 * // Browser: en-US → 'en'
 * // Browser: de-DE → 'de'
 * // Browser: fr-FR → 'de' (fallback)
 */
export const getBrowserLanguage = (): SupportedLanguage => {
  if (typeof navigator === 'undefined' || !navigator || !navigator.language) {
    return 'de'; // SSR/test safety
  }

  return navigator.language.toLowerCase().startsWith('en') ? 'en' : 'de';
};
